import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import LetterAvatar from "../../../../components/LetterAvatar";
import { useNavigate } from "react-router-dom";
import { getStudentById } from "../../../../services/student.service";


const Row = ({ item, value, onChange, onClick }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (e) {
      return dateString;
    }
  };

  const handleRowClick = async () => {
    if (onClick) {
      onClick(item.id);
    }

    try {
      // Récupérer les données complètes de l'étudiant avant de naviguer
      const studentData = await getStudentById(item.id, { expand: 'formation,company' });
      navigate(`/admin/students/${item.id}`, { state: { student: studentData } });
    } catch (error) {
      console.error('Erreur lors de la récupération des données de l\'étudiant:', error);
      // Naviguer quand même avec les données partielles
      navigate(`/admin/students/${item.id}`, { state: { student: item } });
    }
  };

  return (
    <>
      <div className={styles.row} onClick={handleRowClick} style={{ cursor: 'pointer' }}>
        <div className={styles.col}>
        </div>

        <div className={styles.col}>
          <div className={styles.item}>
            <div className={styles.avatar}>
              <LetterAvatar
                firstName={item.first_name || ''}
                lastName={item.last_name || ''}
                size={48}
              />
            </div>
            <div className={styles.details}>
              <div className={styles.user}>{`${item.first_name || ''} ${item.last_name || ''}`}</div>
              <div className={styles.login}>
                {(item.expand?.formation && Object.keys(item.expand.formation).length > 0) ? 
                  item.expand.formation.exact_title_of_qualification : 'Aucune formation'}
              </div>
              <div className={styles.email}>{item.email || 'N/A'}</div>
            </div>
          </div>
        </div>

        <div className={styles.col}>
          <div className={styles.email}>{item.email || 'N/A'}</div>
          <div className={styles.email}>{item.phone || 'N/A'}</div>
        </div>

        <div className={styles.col}>
          <div className={styles.date}>{formatDate(item.inscription_at)}</div>
        </div>

        <div className={styles.col}>
          <div className={cn('status-type', 'status-blue-dark')}>
            {item.expand?.company_id?.name || 'N/A'}
          </div>
        </div>

        <div className={styles.col}>
          <div className={cn(
            'status-type',
            item.file_status === 'Complet' ? 'status-green-dark' : 'status-red-dark'
          )}>
            {item.file_status || 'Incomplet'}
          </div>
        </div>

        <div className={styles.col}>
          <div className={cn(
            'status-type',
            item.status === 'Inscrit' ? 'status-green-dark' :
              item.status === 'Diplomé' ? 'status-blue-dark' :
                'status-red-dark'
          )}>
            {item.status || 'Non défini'}
          </div>
        </div>
      </div>
    </>
  );
};

export default Row;